import 'bootstrap/dist/css/bootstrap.min.css';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './state/store'
import './registerServiceWorker'
import VueDraggable from 'vue-draggable'
import vClickOutside from 'v-click-outside'
import firebase from 'firebase';
import vuetify from './plugins/vuetify'
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
	iconUrl: require('leaflet/dist/images/marker-icon.png'),
	shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Your web app's Firebase configuration
var firebaseConfig = {
	apiKey: "AIzaSyBOTWkbgJZol8Lkq8lnZxWGq70oomzok6A",
	authDomain: "orchestra-storyteller.firebaseapp.com",
	databaseURL: "https://orchestra-storyteller.firebaseio.com",
	projectId: "orchestra-storyteller",
	storageBucket: "orchestra-storyteller.appspot.com",
	messagingSenderId: "706708646643",
	appId: "1:706708646643:web:b3987d386d8d67d52a6586"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

Vue.use(VueDraggable);
Vue.use(vClickOutside);

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app')
